var _g;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgLeftArrow(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    width: 25.411,
    height: 20.322,
    viewBox: "0 0 25.411 20.322",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _g || (_g = /*#__PURE__*/React.createElement("g", {
    id: "Group_11831",
    "data-name": "Group 11831",
    transform: "translate(-39.089 -142.839)"
  }, /*#__PURE__*/React.createElement("g", {
    id: "Group_11830",
    "data-name": "Group 11830",
    transform: "translate(-35 -37.25)"
  }, /*#__PURE__*/React.createElement("line", {
    id: "Line_733",
    "data-name": "Line 733",
    x1: 10,
    y2: 8.75,
    transform: "translate(75.5 181.5)",
    fill: "none",
    stroke: "#707070",
    strokeLinecap: "round",
    strokeWidth: 2
  }), /*#__PURE__*/React.createElement("line", {
    id: "Line_734",
    "data-name": "Line 734",
    x1: 10,
    y1: 8.75,
    transform: "translate(75.5 190.25)",
    fill: "none",
    stroke: "#707070",
    strokeLinecap: "round",
    strokeWidth: 2
  })), /*#__PURE__*/React.createElement("line", {
    id: "Line_735",
    "data-name": "Line 735",
    x2: 23,
    transform: "translate(41.5 153.5)",
    fill: "none",
    stroke: "#707070",
    strokeWidth: 2
  }))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgLeftArrow);
export default __webpack_public_path__ + "static/media/left-arrow.0d1972dd78f2aeadf7a14b570407e982.svg";
export { ForwardRef as ReactComponent };